!function($) {

  // Add custom JavsScript here
  // --------------------------



  // Document ready
  $(function() {
	$('.PIN_1469852943730_button_pin.PIN_1469852943730_tall').addClass('float-top');

  });

}(jQuery);